import React, { useEffect }   from 'react';
import { useRecoilValue } from 'recoil';
import useReservationsPatient from 'src/Patient/hooks/useReservationsPatient';
import { reservationsRecentsState } from 'src/Patient/state/atoms';
import EmptyCalendar from 'src/shared/components/notFoundData/EmptyCalendar';
import HoursAvailableSkeleton from 'src/shared/components/skeletons/HoursAvailableSkeleton';
//import { reservasPorPaciente } from 'src/__mocks__/reservasPorPaciente'
import CardReservation from './CardReservation'

const ListReservations = () => {
    const reservationsRecents = useRecoilValue(reservationsRecentsState);
    //const [loading, setLoading] = useState(false)
    const { reservationsRecentsCallback, loading } = useReservationsPatient()

    // const reservationsRecentsCallback = useRecoilCallback(({ snapshot }) => async () => {
    //     setLoading(true)
    //     try {
    //         if( user.payload) {
    //             const reservationsFetch = await snapshot.getPromise(listReservationsRecentsFetchState(user.payload.uswRut));
    //             setReservationsRecents(reservationsFetch)
    //         }        
    //     } catch (error) {
    //         catchErrorApi(error);
    //     } finally {
    //         setLoading(false)
    //     }
    // }, []);

    useEffect(() => {
        reservationsRecentsCallback()

        // return () => {
        //     reservationsRecentsCallback()
        // }
    }, [reservationsRecentsCallback])

    if(loading) return <HoursAvailableSkeleton />
    if(!loading && reservationsRecents && reservationsRecents.length === 0) return <EmptyCalendar text={"No ha realizado reservas aún"} />

    return (
        <div>
            {
                reservationsRecents.map((el, index) => (
                    <CardReservation key={`${el.ptdRut}_${index}`} professional={el} />
                ))
            }
        </div>
    )
}

export default ListReservations
